<p-toast [style]="{marginTop: '80px'}"></p-toast>
<p-confirmDialog header="Confirmation" icon="pi pi-exclamation-triangle"></p-confirmDialog>
<p-table #pt [value]="paymentConfirms" [lazy]="true" (onLazyLoad)="loadLazy($event)" dataKey="paymentConfirmId" selectionMode="single"
  [(selection)]="paymentConfirm" [loading]="loading" [paginator]="showPagination" [rows]="25"
  [rowsPerPageOptions]="[25,100,200,500,1000,5000,10000]" showCurrentPageReport="true"
  currentPageReportTemplate="{totalRecords} results. Page {currentPage} of {totalPages}" [totalRecords]="recordTotal"
  sortMode="multiple" [multiSortMeta]="multiSortMeta" styleClass="p-datatable-striped" [ngStyle]="{'width': 'auto'}"
  [resizableColumns]="true" [autoLayout]="true" [responsive]="true" [scrollable]="true" scrollHeight="80vh">

  <ng-template pTemplate="caption">
    <div class="d-block text-end justify-content-between align-items-center">
      <h1 style="float: left;margin: 6px;">PaymentConfirms</h1>
      <span class="d-inline-flex flex-wrap align-items-center">
        <span class="p-float-label me-2">
          <p-calendar inputId="checkInStart" [(ngModel)]="checkInStartDate" (onSelect)="onCheckInOutDateChange()" (onClearClick)="onCheckInOutDateChange()" [showButtonBar]="true" [style]="{'width':'160px'}" appendTo="body"></p-calendar>
          <label for="checkInStart">Check-In Start</label>
        </span>
        <span class="p-float-label me-2">
          <p-calendar inputId="checkInEnd" [(ngModel)]="checkInEndDate" (onSelect)="onCheckInOutDateChange()" (onClearClick)="onCheckInOutDateChange()" [showButtonBar]="true" [style]="{'width':'160px'}" appendTo="body"></p-calendar>
          <label for="checkInEnd">Check-In End</label>
        </span>
        <span class="p-float-label me-2">
          <p-calendar inputId="checkOutStart" [(ngModel)]="checkOutStartDate" (onSelect)="onCheckInOutDateChange()" (onClearClick)="onCheckInOutDateChange()" [showButtonBar]="true" [style]="{'width':'160px'}" appendTo="body"></p-calendar>
          <label for="checkOutStart">Check-Out Start</label>
        </span>
        <span class="p-float-label me-2">
          <p-calendar inputId="checkOutEnd" [(ngModel)]="checkOutEndDate" (onSelect)="onCheckInOutDateChange()" (onClearClick)="onCheckInOutDateChange()" [showButtonBar]="true" [style]="{'width':'160px'}" appendTo="body"></p-calendar>
          <label for="checkOutEnd">Check-Out End</label>
        </span>

        <!--clear filters-->
        @if (showFilter) {
          <button pButton pRipple class="p-button-text"
            style="font-size: 80%; padding: 0.643rem 0.75rem !important; margin-right:10px;"
          (click)="reloadPage()">Clear Filters</button>
        }

        <app-import-export importEnabled="false" [dataRetrived]="paymentConfirms" (exportDataSelected)="exportSelected($event)" [columns]="columns" [importDisabled]="true"></app-import-export>

        <!--add new-->
        <!-- <button *ngIf="!outlineNewButton" pButton pRipple class="p-button-outlined" style="padding: 0.643rem 0.75rem !important;"
      (click)="onOpenFormAdd()">New PaymentConfirm +</button>
      <button *ngIf="outlineNewButton" pButton pRipple class="p-button" style="padding: 0.643rem 0.75rem !important;"
      (click)="onOpenFormAdd()">New PaymentConfirm +</button> -->
    </span>
  </div>
</ng-template>
<ng-template pTemplate="header">
  <tr>
    @for (col of columns; track col) {
      <th [pSortableColumn]="col.field" [ngStyle]="{'width': 'auto'}">
        {{col.header}}
        <p-sortIcon [field]="col.field"></p-sortIcon>
      </th>
    }
    <!-- <th [ngStyle]="{'width': 'auto'}"></th> -->
  </tr>
  @if (showFilter) {
    <tr>
      <th [ngStyle]="{'width': 'auto'}">
        <!-- <input [ngStyle]="{'width':'50px','min-width':'100%'}" pInputText type="text" (input)="pt.filter($event.target.value, 'reservationVO.shortTermRentalVO.shortTermRentalId', 'in')"> -->
        <p-multiSelect dropdownIcon="fa fa-caret-down" [style]="{'width':'50px','min-width':'100%'}" [options]="properties" appendTo="body"
          (onChange)="pt.filter($event.value, 'reservationVO.shortTermRentalVO.shortTermRentalId', 'in')" styleClass="p-column-filter"
          placeholder="Filter" [showClear]="false" optionLabel="propertyCode" optionValue="shortTermRentalId">
          <ng-template let-option pTemplate="item">
            <span>{{option.propertyCode}}</span>
          </ng-template>
        </p-multiSelect>
      </th>
      <th [ngStyle]="{'width': 'auto'}"><input [ngStyle]="{'width':'50px','min-width':'100%'}" pInputText type="text" (input)="pt.filter($event.target.value, 'reservationVO.shortTermRentalVO.addressState', 'in')"></th>
      <th [ngStyle]="{'width': 'auto'}"></th>
      <!-- <th [ngStyle]="{'width': 'auto'}"><input [ngStyle]="{'width':'50px','min-width':'100%'}" pInputText
      style="width:100px;" type="date"
    (input)="pt.filter($event.target.value, 'paymentConfirmVO.paymentProcessDate', 'in')"></th> -->
    <th [ngStyle]="{'width': 'auto'}"></th>
    <th [ngStyle]="{'width': 'auto'}"></th>
    <th [ngStyle]="{'width': 'auto'}"><input [ngStyle]="{'width':'50px','min-width':'100%'}" pInputText type="text" (input)="pt.filter($event.target.value, 'reservationVO.guestProfileVO.lastName', 'in')"></th>
    <th [ngStyle]="{'width': 'auto'}"><input [ngStyle]="{'width':'50px','min-width':'100%'}" pInputText type="text" (input)="pt.filter($event.target.value, 'reservationVO.guestProfileVO.lastName', 'in')"></th>
    <th [ngStyle]="{'width': 'auto'}"><input [ngStyle]="{'width':'50px','min-width':'100%'}" pInputText type="text" (input)="pt.filter($event.target.value, 'orderInvoiceVO.orderVO.orderId', 'in')"></th>
    <th [ngStyle]="{'width': 'auto'}">
      <p-checkbox binary="true" [(ngModel)]="activeFilter" inputId="activeFilter" label=""
        (onChange)="onActiveFilterChange($event)">
      </p-checkbox>
    </th>
    <th [ngStyle]="{'width': 'auto'}">
      <p-checkbox binary="true" [(ngModel)]="activeFilterForPaymentConfirmId" inputId="activeFilterForPaymentConfirmId" label=""
        (onChange)="onActiveFilterChangeForPaymentConfirm($event)">
      </p-checkbox>
    </th>
    <th [ngStyle]="{'width': 'auto'}"><input [ngStyle]="{'width':'50px','min-width':'100%'}" pInputText type="text" (input)="pt.filter($event.target.value, 'paymentConfirmVO.amount', 'in')"></th>
    <th [ngStyle]="{'width': 'auto'}"><input [ngStyle]="{'width':'50px','min-width':'100%'}" pInputText type="text" (input)="pt.filter($event.target.value, 'paymentConfirmVO.paymentProcessAmount', 'in')"></th>
    <th>
      <p-dropdown #aa [style]="{'width':'50px','min-width':'100%'}" [options]="paymentTypes" appendTo="body"
        (onChange)="pt.filter($event.value, 'paymentConfirmVO.paymentType', 'in')" styleClass="p-column-filter"
        placeholder="Filter" [showClear]="true" optionLabel="name" optionValue="value">
        <ng-template let-option pTemplate="item">
          <span>{{option.name}}</span>
        </ng-template>
      </p-dropdown>
    </th>
    <th>
      <p-dropdown #aa [style]="{'width':'50px','min-width':'100%'}" [options]="invoiceDetailTypes" appendTo="body"
        (onChange)="pt.filter($event.value, 'type', 'in')" styleClass="p-column-filter"
        placeholder="Filter" [showClear]="true" optionLabel="name" optionValue="value">
        <ng-template let-option pTemplate="item">
          <span>{{option.name}}</span>
        </ng-template>
      </p-dropdown>
    </th>
    <th [ngStyle]="{'width': 'auto'}"><input [ngStyle]="{'width':'50px','min-width':'100%'}" pInputText type="text" (input)="pt.filter($event.target.value, 'paymentConfirmVO.paymentTransactionConfirmNumber', 'in')"></th>
    <th [ngStyle]="{'width': 'auto'}"><input [ngStyle]="{'width':'50px','min-width':'100%'}" pInputText type="text" (input)="pt.filter($event.target.value, 'paymentConfirmVO.paymentProceedsDepositedToAccountIdentifier', 'in')"></th>
    <th [ngStyle]="{'width': 'auto'}"><input [ngStyle]="{'width':'50px','min-width':'100%'}" pInputText type="text" (input)="pt.filter($event.target.value, 'paymentConfirmVO.paymentSourceAccountIdentifier', 'in')"></th>
  </tr>
}
</ng-template>
<ng-template pTemplate="body" let-paymentConfirm>
  <tr>
    <td>{{paymentConfirm?.propertyCode}} </td>
    <td>{{paymentConfirm?.addressState}} </td>
    <td>{{paymentConfirm?.paymentProcessDate | date}}</td>
    <td>{{paymentConfirm?.checkInDateTime | date}}</td>
    <td>{{paymentConfirm?.checkOutDateTime | date}}</td>
    <td>{{paymentConfirm?.firstName}} {{paymentConfirm?.lastName}}</td>
    <td>{{paymentConfirm?.guestNameHash}}</td>
    <td><a href="order/{{paymentConfirm?.orderId}}" target="_blank">{{paymentConfirm?.orderId}}</a></td>
    <td>{{paymentConfirm?.reservationId}}</td>
    <td>{{paymentConfirm?.paymentConfirmId}}</td>
    <td>{{paymentConfirm.amount| currency : 'USD' : 'symbol' : '1.2-2'}}</td>
    <td>{{paymentConfirm.paymentProcessAmount| currency : 'USD' : 'symbol' : '1.2-2'}}</td>
    <td>{{getPaymentTypeName(paymentConfirm)}}</td>
    <td>{{getInvoiceDetailTypeName(paymentConfirm)}}</td>
    <!-- <td>{{paymentConfirm.paymentGatewayProvider}}</td> -->
    <td>{{paymentConfirm.paymentTransactionConfirmNumber}}</td>
    <td>{{paymentConfirm.paymentProceedsDepositedToAccountIdentifier}}</td>
    <td>{{paymentConfirm.paymentSourceAccountIdentifier}}</td>
    <!-- <td>{{paymentConfirm.paymentResultIndicator}}</td>
    <td>{{getPaymentCreditCardRequestsName(paymentConfirm)}}</td>

    <td>{{paymentConfirm.paymentInvoiceNumber}}</td> -->
    <!-- <td><span style="float:none">
    <a>
      <i class="pi pi-pencil" aria-hidden="true"
      style="color:blue; font-size:110%; padding-right:20px;" (click)="onOpenFormEdit(paymentConfirm)"></i>
    </a>
  </span>
</td> -->
</tr>
</ng-template>
</p-table>